import { EXP } from '../types';
export default {
  type: EXP,
  service: 'expanse.tech',
  url: 'https://node.expanse.tech/',
  port: 443,
  auth: false,
  username: '',
  password: ''
};
